import { css } from '@emotion/react';

export const tariffDetailsStyles = {
    container: css({
        marginTop: 10,
    }),
    blockTitle: css({
        fontSize: 12,
        fontWeight: 500,
        textTransform: 'uppercase',
        color: '#303030',
        marginBottom: 4,
    }),
    rows: css({
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    }),
    row: css({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        gap: 12,
    }),
    name: css({
        fontSize: 12,
        fontWeight: 500,
        color: '#000000',
        whiteSpace: 'pre-wrap',
        maxWidth: '49%',
    }),
    value: css({
        fontSize: 14,
        fontWeight: 700,
        color: '#000000',
        textAlign: 'right',
        whiteSpace: 'pre-wrap',
        maxWidth: '50%',
    }),
    sectionGap: css({
        marginTop: 12,
    }),
    daySwitcherContainer: css({
        marginBottom: 12,
        width: '100%',
    }),
    tierTable: css({
        width: '100%',
        borderCollapse: 'collapse',
    }),
    tierTh: css({
        textAlign: 'left',
        fontSize: 12,
        fontWeight: 500,
        textTransform: 'uppercase',
        color: '#303030',
        paddingBottom: 6,
    }),
    tierTd: css({
        fontSize: 14,
        color: '#000000',
        padding: '3px 0',
    }),
    tierTdValue: css({
        fontSize: 14,
        fontWeight: 700,
        color: '#000000',
        padding: '3px 0',
        textAlign: 'right',
        whiteSpace: 'nowrap',
    }),
};

